import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

const classes = {
    instruction: css`
        margin: 10px 0;
        font-weight: bold;
    `,
    divider: css`
        margin: 10px 0;
    `,
    dataTypeSpecificComponents: css`
        margin: 10px 0;
    `,
    radio: css`
        padding: 2px 12px;
    `,
};

const SelectNationalSubnational = (props) => {
    console.log("SelectNationalSubnational props:", props);
    const { onSelectRunType, selectedRunType } = props;

    const { t } = useTranslation();

    const disableSubnational = props.regions.length === 0;

    React.useEffect(() => {
        if (disableSubnational && selectedRunType !== "National") {
            onSelectRunType("National");
        }
    }, [onSelectRunType, disableSubnational, selectedRunType]);

    return (
        <div>
            <div className={classes.instruction}>3b. {t("Select national/subnational")}</div>

            <FormControl component="fieldset">
                <RadioGroup
                    aria-label="Run type"
                    value={selectedRunType}
                    onChange={(_, value) => onSelectRunType(value)}
                >
                    <FormControlLabel
                        value="National"
                        control={<Radio className={classes.radio} />}
                        label={t("National")}
                    />
                    <FormControlLabel
                        value="Subnational"
                        control={<Radio className={classes.radio} />}
                        label={t("Single subnational area")}
                        disabled={disableSubnational}
                    />
                    <FormControlLabel
                        value="All"
                        control={<Radio className={classes.radio} />}
                        label={t("All (national + subnationals)")}
                        disabled={disableSubnational}
                    />
                </RadioGroup>
            </FormControl>

            <SelectPopulation
                selectedRunType={props.selectedRunType}
                regions={props.regions}
                onSelectRegion={props.onSelectRegion}
            />

            <Divider className={classes.divider} />
        </div>
    );
};

const SelectPopulation = (props) => {
    const { t } = useTranslation();

    if (props.selectedRunType === "All") {
        return null;
    }

    if (props.selectedRunType === "National") {
        return null;
    }

    if (props.selectedRunType === "Subnational") {
        return (
            <div style={{ padding: "10px 0" }}>
                <Select
                    placeholder={t("Select region")}
                    options={props.regions}
                    value={props.selectedRegionValue}
                    noOptionsMessage={() => "No regions available"}
                    className={classes.select}
                    onChange={({ value }) => {
                        props.onSelectRegion(props.regions.find((region) => region.value === value).label);
                    }}
                />
            </div>
        );
    }

    return null;
};

export default SelectNationalSubnational;
